import React from 'react';
import { Route, Routes } from "react-router-dom";
import { Home } from "../Home/Home";
import { ResetPassword } from "../Auth/login/resetPassword";
import { NotFound } from "../shared-components/NotFound";
import { ProfileError } from "../shared-components/ProfileError";
import { HOME, LOGIN, RESET, MYMESSAGES, PROFILE, VIEWMESSAGES, LOAD, IFRAME, MYLOUIETASKS, INCOM, AUTH_COMPLETE, INCOMPLIANCEDASH, PROFILE_ERROR } from "../../../utils/CONSTANTS";
import IndiaComplianceDashboard from "../IndiaComplianceDashboard/IndiaComplianceDashboard";
import Login from "../Auth/login/login";
import AuthComplete from "../Auth/login/authComplete";
import ProtectedRoute from "../../../routes/protectedRoutes";
import PublicRoute from "../../../routes/publicRoutes";
import { AuthContextProvider } from "../shared-components/authContext";
import { InitialLoadPage } from "./initialLoadPage";
import { MyMessages } from '../myMessages/MyMessages';
import { PrOfilePage } from '../profilePage/profilePage';
import { ViewOGEmail } from '../myMessages/viewEmail/ViewOGEmail';
import { Iframe } from '../iFrame/Iframe';
import MyLouieTasks from "../ProfileLanding/Resources/myLouieTasks";
import INComPage from "../ProfileLanding/Tasks/mainPageIN";

export default function Header() {

  return (
    <>
      <AuthContextProvider>
        <Routes>
          <Route element={<PublicRoute />}>
            {/*
              AUTH_COMPLETE must come BEFORE LOGIN (which is "/:id?") because
              "/:id?" would otherwise swallow "/auth/complete" — React Router v6
              picks the most-specific match, but the static segment must be
              registered for that ranking to work in our favor.
            */}
            <Route exact path={AUTH_COMPLETE} element={<AuthComplete />} />
            <Route exact path={LOGIN} element={<Login />} />
          </Route>
          <Route element={<ProtectedRoute roleRequired=" " />}>
            <Route exact path={LOAD} element={<InitialLoadPage />} />
            <Route exact path={HOME} element={<Home />} />
            <Route exact path={PROFILE} element={<PrOfilePage />} />
            <Route exact path={IFRAME} element={<Iframe />} />
            <Route exact path={MYLOUIETASKS} element={<MyLouieTasks />} />
            <Route exact path="*" element={<NotFound />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route exact path={MYMESSAGES} element={<MyMessages />} />
            <Route exact path={INCOM} element={<INComPage />} />
            <Route exact path={INCOMPLIANCEDASH} element={<IndiaComplianceDashboard />} />
          </Route>
          <Route element={<ProtectedRoute roleRequired="OG" />}>
            <Route exact path={VIEWMESSAGES} element={<ViewOGEmail />} />
          </Route>
          <Route>
            <Route exact path={RESET} element={<ResetPassword />} />
            <Route exact path={PROFILE_ERROR} element={<ProfileError />} />
          </Route>
        </Routes>
      </AuthContextProvider>
    </>
  );
}

